<template>
    <div class="bg_white loginbox" >
      <div class='header'>
        <img src="../../asset/images/wechat.png" alt="">
      </div>
      

      <div class='content'>
            <div>申请获取以下权限</div>
            <p>获得你的公开信息(昵称，头像等)</p>
      </div>

      <van-button type="primary"  plain class="mt20" @click="goWxLogin()">授权登陆</van-button>
    </div>
</template>

<script>
import { testLogin,regist } from '../../api/custom';
export default {
  data() {
    return {
        param:{
          code:""
        }
    }

   },
   created(){
    this.param.code =this.common.getQueryString("code")
    // let z=this
    if(this.common.getQueryString("code") !=null){
      regist(this.param.code).then(res=>{
        if (res.success) {
          localStorage.setItem("token",res.data.token)
          this.$toast({
            type: 'success',
            message: 'success',
          
          })
          this.$router.push("/home")
        } else {
          this.$toast({
            type: 'fail',
            message: res.message,

          })
        }
      })
    }
   },
   methods: {
    goTestlogin(){
      testLogin().then(res=>{
        if(res.success){
          localStorage.setItem("token",res.data.token)
          this.$router.push("/home")
        }
      })
      
    },
    goWxLogin(){
      window.location.href="http://api.fzsyjxh.com/api/v1/wxLogin"
    }
    
    
  }

};
</script>

<style lang="less">
.header {
  
  border-bottom: 1px solid #ccc;
  text-align: center;
  width: 100%;
  height: 300px;
  line-height: 450px;
}
.loginbox{
  box-sizing: border-box;
  padding:15px;
  text-align: center;
  
  
}
.header image {
  width: 200px;
  height: 200px;
}

.content {
   margin-left: 20px;
   margin-top: 20px;
  // margin-bottom: 90px;
  font-size: 14px;
  text-align: left;
}
.mt20{
  margin-top: 40px;
}
.content text {
  display: block;
  color: #9d9d9d;
  margin-top: 40px;
}

.bottom {
  border-radius: 80px;
  margin: 70px 50px;
  font-size: 35px;
}

</style>

